import { resetPasswordEmployee } from "@/api/employee";
import { checkEmployeeHierarchy } from "@/api/utils";
import { EmployeeProps } from "@/interfaces/employee_type";
import { RouteButton, OrangeButton } from "../../Buttons";
import { useAuth } from "@/App";
import { Error_Component } from "../../misc";   
/**
 * A Component that shows when the user clicks on a row on the table.
 *
 * This is where the description of the project will be stored
 *
 * But also I want buttons to see a report or edit the project
 *
 * @param param0 data The props of a give row
 *
 */

export const EmployeeRow = ({ data }: { data: EmployeeProps; }) => {
    const { user } = useAuth();
    if (!user) return <Error_Component errorString="User not found" />;

    const roleHierarchy = checkEmployeeHierarchy(user.role)

    const handleResetPassword = async (id: string) => {
        if (confirm("Are you sure you want to reset the password for this employee? This will have them repeat the onboarding process to reset their password.")) {
            const response = await resetPasswordEmployee(id);

            if (response === 200) {
                alert("Password reset successful. They will have to login again with the default password.");
            } else {
                alert("Password reset failed. Please contact IT or admin.");
            }
        }
    };

    return (
        <div className="flex flex-col gap-4 mx-2 bg-slate-50">
            <div className="flex flex-row gap-2">
                <RouteButton route={"/employees/update_employee/" + data.id} text="Edit" />
                {(roleHierarchy === "ADMIN" || roleHierarchy === "IT" || user.role === "CEO") && <OrangeButton onClick={() => handleResetPassword(data.id ?? "")}>Reset Password</OrangeButton>}
            </div>
        </div>
    );
};
